import clsx from 'clsx'

import { useBlock } from '@tribeplatform/react-slate-kit/hooks'
import {
  BlockWrapperComponent,
  LayoutBlockProps,
  LBC,
  UnknownProps,
} from '@tribeplatform/react-slate-kit/types'

import { EditorBlockExtraContext } from '../types'

export const LayoutWrapper: BlockWrapperComponent = ({
  Block,
  childrenBlocks,
}) => {
  const {
    block: { compiledProps },
    extraContext: { focused, selected, activated },
  } = useBlock<UnknownProps, EditorBlockExtraContext>()

  const LayoutBlock = Block as LBC<LayoutBlockProps>
  const layoutProps = compiledProps as LayoutBlockProps
  return (
    <LayoutBlock
      {...layoutProps}
      containerProps={{
        className: clsx(
          layoutProps?.containerProps?.className,
          (selected || focused) && [
            'ring-offset-0 ring-2',
            focused && 'ring-focused',
            selected && 'ring-focused',
          ],
          activated && 'relative z-40 bg-background',
        ),
      }}
    >
      {childrenBlocks}
    </LayoutBlock>
  )
}
